import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getShiftType, updateShiftType } from "../../actions/shiftTypeActions";
import { Grid, TextField, FormControlLabel, Checkbox } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Form from "./Form";

class UpdateShiftTypeForm extends Component {
  state = {
    name: "",
    price: 0.0,
    isCardPhotoRequired: false,
  };

  componentDidMount() {
    this.props.getShiftType(this.props.id).then((response) => {
      this.setState(response);
    });
  }

  updateShiftType = (e) => {
    e.preventDefault();
    this.props.updateShiftType(this.props.id, this.state);
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleCheckboxChange = (e) =>
    this.setState({ [e.target.name]: e.target.checked });

  handlePriceChange = (e) =>
    this.setState({ [e.target.name]: parseFloat(e.target.value).toFixed(2) });

  render() {
    return (
      <Form
        onSubmit={this.updateShiftType}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="name"
              name="name"
              label="Naam *"
              value={this.state.name}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="price"
              name="price"
              type="number"
              label="Uurtarief *"
              value={this.state.price}
              onChange={this.handleChange}
              onBlur={this.handlePriceChange}
              fullWidth
              InputProps={{
                min: ".01",
                step: ".01",
                startAdornment: (
                  <InputAdornment position="start">€</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  id="isCardPhotoRequired"
                  name="isCardPhotoRequired"
                  checked={this.state.isCardPhotoRequired}
                  onChange={this.handleCheckboxChange}
                />
              }
              label="Pas uploaden verplicht?"
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

UpdateShiftTypeForm.propTypes = {
  id: PropTypes.string.isRequired,
  getShiftType: PropTypes.func.isRequired,
  updateShiftType: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shifttype.updateShiftType.successMessage,
  errorMessage: state.shifttype.updateShiftType.errorMessage,
  isFetching:
    state.shifttype.getShiftType.isFetching ||
    state.shifttype.updateShiftType.isFetching,
});

export default connect(mapStateToProps, { getShiftType, updateShiftType })(
  UpdateShiftTypeForm,
);



// WEBPACK FOOTER //
// ./src/components/forms/UpdateShiftTypeForm.js